/*
 * サイズの測り方モーダル
 *
 * 旧テーマは外部CDNの slick-carousel で表示していたものの置き換え。
 * 必要なのは「5枚を順に見る」だけなので、自前で実装している。
 *
 * 本文中の <a href="#iroiro-size-chart"> を押すと開く。
 * Shopify の richtext 設定は span への class を許可しないため、
 * リンクで開く形にしている。JSが動かない場合でも
 * アンカーとして要素まで移動するので致命的に壊れない。
 */
(function () {
  'use strict';

  function init() {
    var modal = document.getElementById('iroiro-size-chart');
    if (!modal || modal.dataset.iroiroReady === 'true') return;
    modal.dataset.iroiroReady = 'true';

    var slides = Array.prototype.slice.call(
      modal.querySelectorAll('.iroiro-size-chart__slide')
    );
    if (slides.length === 0) return;

    var counter = modal.querySelector('.iroiro-size-chart__counter');
    var current = 0;
    var lastFocused = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-current', i === current);
      });
      if (counter) counter.textContent = current + 1 + ' / ' + slides.length;
    }

    function open(event) {
      if (event) event.preventDefault();
      lastFocused = document.activeElement;
      modal.hidden = false;
      show(0);
      // 背面がスクロールしないようにする
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.iroiro-size-chart__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    // 本文中のリンクから開く（本文は後から編集されうるので委譲で拾う）
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(
        'a[href="#iroiro-size-chart"], .iroiro-size-chart-open'
      );
      if (trigger) open(event);
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('.iroiro-size-chart__close')) return close();
      if (event.target.closest('.iroiro-size-chart__prev')) return show(current - 1);
      if (event.target.closest('.iroiro-size-chart__next')) return show(current + 1);
      // パネルの外側を押したら閉じる
      if (!event.target.closest('.iroiro-size-chart__panel')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    show(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
